import { render, staticRenderFns } from "./PushNotificationsTable.vue?vue&type=template&id=3f59f22e&"
import script from "./PushNotificationsTable.vue?vue&type=script&lang=js&"
export * from "./PushNotificationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports